export default {
  meta: {
    title: '个人绩效报表',
    url: '/fishtogether/individualkpireport', // 埋点用，记录所属模块
  },
};
